import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Cell } from '../../base/styled';

import {
  LabelWidget,
  ErrorChangeWidget,
  BarChartWidget,
} from '../../widgets';

const CmsTopHits = (props) => {

  const {
    title = '',
    barChart: {
      error: errorBarChart = null,
      data: barChart = null,
    } = {},
    breakouts: {
      error: errorBreakouts = null,
      data: {
        errorChange0 = null,
        errorChange1 = null,
        errorChange2 = null,
        errorChange3 = null,
        errorChange4 = null,
        errorChange5 = null,
      } = {},
    } = {},
  } = props;

  return (
    <div className="dashboard">
      <Grid
        columns={6}
        rows="6% 60% 24%"
        alignContent="stretch"
        height="inherit"
      >
        <Cell width={6}>
          <LabelWidget input={{ data: { title } }} />
        </Cell>
        <Cell width={6}>
          <BarChartWidget input={{ error: errorBarChart, data: barChart }} />
        </Cell>
        <Cell>
          <ErrorChangeWidget input={{ error: errorBreakouts, data: errorChange0 }} />
        </Cell>
        <Cell>
          <ErrorChangeWidget input={{ error: errorBreakouts, data: errorChange1 }} />
        </Cell>
        <Cell>
          <ErrorChangeWidget input={{ error: errorBreakouts, data: errorChange2 }} />
        </Cell>
        <Cell>
          <ErrorChangeWidget input={{ error: errorBreakouts, data: errorChange3 }} />
        </Cell>
        <Cell>
          <ErrorChangeWidget input={{ error: errorBreakouts, data: errorChange4 }} />
        </Cell>
        <Cell>
          <ErrorChangeWidget input={{ error: errorBreakouts, data: errorChange5 }} />
        </Cell>
      </Grid>
    </div>
  );
};

CmsTopHits.defaultProps = null;

CmsTopHits.propTypes = {
  title: PropTypes.string,
  barChart: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape(BarChartWidget.dataPropType),
  }),
  breakouts: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({
      barChart: PropTypes.shape(BarChartWidget.dataPropType),
      errorChange0: PropTypes.shape(ErrorChangeWidget.dataPropType),
      errorChange1: PropTypes.shape(ErrorChangeWidget.dataPropType),
      errorChange2: PropTypes.shape(ErrorChangeWidget.dataPropType),
      errorChange3: PropTypes.shape(ErrorChangeWidget.dataPropType),
      errorChange4: PropTypes.shape(ErrorChangeWidget.dataPropType),
      errorChange5: PropTypes.shape(ErrorChangeWidget.dataPropType),
    }),
  }),
};

export default CmsTopHits;
